import { createFileRoute, Link, Outlet, redirect } from '@tanstack/react-router'

import {
  BillingBlocked,
  OperationalBlockedActions,
} from '#components/features/billing/billing-access'
import { AdminMobileHeader } from '#components/layout/admin-mobile-header'
import { AppSidebar } from '#components/layout/app-sidebar'
import { WorkspaceLoadingSkeleton } from '#components/layout/workspace-loading-skeleton'
import { Button } from '#components/ui/button'
import { SidebarInset, SidebarProvider } from '#components/ui/sidebar'
import { useLogoutWaiter } from '#hooks/api/use-auth-actions'
import { useBillingAccess } from '#hooks/api/use-billing-access'
import { authQueryOptions, useAuth } from '#hooks/use-auth'
import { posthog } from '#lib/posthog'
import { useWaiterStore } from '#stores/use-waiter-store'

export const Route = createFileRoute('/garcom')({
  beforeLoad: async ({ context, location }) => {
    const authData = await context.queryClient.ensureQueryData(authQueryOptions)
    const token = localStorage.getItem('@usecomanda:waiter_token')
    const member = useWaiterStore.getState().waiter
    if (token && !member) {
      localStorage.removeItem('@usecomanda:waiter_token')
      if (location.pathname !== '/garcom') throw redirect({ to: '/garcom' })
      return
    }
    if (member?.is_active === false) {
      localStorage.removeItem('@usecomanda:waiter_token')
      posthog.reset()
      useWaiterStore.getState().clearWaiter()
      throw redirect({ to: '/garcom' })
    }

    if (!token && !authData.user && location.pathname !== '/garcom') {
      throw redirect({
        to: '/garcom',
      })
    }

    if (token && member?.role === 'kitchen') throw redirect({ to: '/cozinha' })

    if ((token || authData.user) && location.pathname === '/garcom') {
      throw redirect({
        to: '/mesas',
      })
    }
  },
  pendingComponent: () => <div>Carregando Mesas...</div>,
  component: WaiterLayout,
})

function WaiterLayout() {
  const member = useWaiterStore((state) => state.waiter)
  const { tenantId: adminTenantId } = useAuth()
  const billing = useBillingAccess(member?.tenant_id ?? adminTenantId)
  const { handleLogout } = useLogoutWaiter()
  if ((member || adminTenantId) && billing.isLoading)
    return <WorkspaceLoadingSkeleton />
  if ((member || adminTenantId) && !billing.accessState.canOperate)
    return (
      <BillingBlocked
        state={billing.accessState}
        actions={
          member ? (
            <OperationalBlockedActions onLogout={handleLogout} />
          ) : (
            <>
              <Button asChild>
                <Link to="/planos">Regularizar plano</Link>
              </Button>
              <Button asChild variant="outline">
                <Link to="/historico/pedidos">Consultar histórico</Link>
              </Button>
            </>
          )
        }
      />
    )
  if (adminTenantId && !member)
    return (
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <AdminMobileHeader />
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    )
  return <Outlet />
}
